/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/templates/page.leaders-in-safety.js":
/*!*********************************************************!*\
  !*** ./src/scripts/templates/page.leaders-in-safety.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _page_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./page.js */ \"./src/scripts/templates/page.js\");\n/* harmony import */ var bootstrap_js_dist_tab_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! bootstrap/js/dist/tab.js */ \"./node_modules/bootstrap/js/dist/tab.js\");\n/* harmony import */ var bootstrap_js_dist_tab_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_tab_js__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _components_tabs_dynamic_permalinks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/tabs-dynamic-permalinks */ \"./src/scripts/components/tabs-dynamic-permalinks.js\");\n/* harmony import */ var _components_buttons_pause_html5_video__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/buttons/pause-html5-video */ \"./src/scripts/components/buttons/pause-html5-video.js\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! jquery */ \"jquery\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_4__);\n\r\n\r\n\r\n\r\n\r\n\r\n\r\nanimatedVerticalTabs();\r\n\r\nnavTabs();\r\n\r\n// animated vertical tabs\r\n// Usage:\r\n// add .animated-vertical-tabs class to .tabs\r\n// add data-height=\"###%\" to .progress-bar-animated\r\nfunction animatedVerticalTabs() {\r\n    jquery__WEBPACK_IMPORTED_MODULE_4___default()('.animated-vertical-tabs a[data-toggle=\"tab\"]').on('show.bs.tab', function (e) {\r\n        jquery__WEBPACK_IMPORTED_MODULE_4___default()('.progress-bar-animated').css('height', '0');\r\n    });\r\n\r\n    jquery__WEBPACK_IMPORTED_MODULE_4___default()('.animated-vertical-tabs a[data-toggle=\"tab\"]').on('shown.bs.tab', function (e) {\r\n        var targetTab = jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).attr('href');\r\n        var targetBar = jquery__WEBPACK_IMPORTED_MODULE_4___default()(targetTab).find('.progress-bar-animated');\r\n        targetBar.each(function() {\r\n        var getHeight = jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).data('height');\r\n        jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).css('height', getHeight);  \r\n        });\r\n    });\r\n}\r\n\r\n// Responsive nav tabs - leaders-in-safety page\r\nfunction navTabs() {\r\n    const toggleButton = jquery__WEBPACK_IMPORTED_MODULE_4___default()('.safety-leaders__features-tabs--nav-responsive button');\r\n    const arrowDown = jquery__WEBPACK_IMPORTED_MODULE_4___default()('.safety-leaders__features-tabs--nav-responsive .arrow-down');\r\n    const closeX = jquery__WEBPACK_IMPORTED_MODULE_4___default()('.safety-leaders__features-tabs--nav-responsive .close');\r\n    const tabListItemLink = jquery__WEBPACK_IMPORTED_MODULE_4___default()('.safety-leaders__features-tabs--nav-responsive .nav-link');\r\n\r\n    // On list link click\r\n    tabListItemLink.click(function(e) {\r\n        // geting text of licked link\r\n        var clickedLinkText = jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).text();\r\n        // Changing text on button\r\n        jquery__WEBPACK_IMPORTED_MODULE_4___default()('.safety-leaders__features-tabs--nav-responsive button').html(clickedLinkText);\r\n        // removing all checked marks from list items\r\n        jquery__WEBPACK_IMPORTED_MODULE_4___default()('.safety-leaders__features-tabs--nav-responsive .tabs__list-item span').addClass( \"hide\" );\r\n        // Adding checked mark on clicked list item\r\n        jquery__WEBPACK_IMPORTED_MODULE_4___default()(this).next().removeClass( \"hide\" );\r\n    });\r\n\r\n    // On button click\r\n    jquery__WEBPACK_IMPORTED_MODULE_4___default()('.safety-leaders__features-tabs--nav-responsive button, .safety-leaders__features-tabs--nav-responsive .arrow-down, .safety-leaders__features-tabs--nav-responsive .close').click(function(e) {\r\n        if (arrowDown.hasClass( \"hide\" )) {\r\n        arrowDown.removeClass( \"hide\" );\r\n        closeX.addClass( \"hide\" );\r\n        } else {\r\n        arrowDown.addClass( \"hide\" );\r\n        closeX.removeClass( \"hide\" );\r\n        }\r\n    });\r\n}\n\n//# sourceURL=webpack://starter-theme/./src/scripts/templates/page.leaders-in-safety.js?");

/***/ }),

/***/ "jquery":
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/***/ ((module) => {

module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"template.page.leaders-in-safety": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkstarter_theme"] = globalThis["webpackChunkstarter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./src/scripts/templates/page.leaders-in-safety.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;